import { IObject } from "@quest/base-core";

export let eventDispatchers: IObject = {
  SHOW_POSTLOADING_VIEW: "SHOW_POSTLOADING_VIEW",
  UPDATE_JACKPOT_METERS_VALUES: "UPDATE_JACKPOT_METERS_VALUES",
  UPDATE_JACKPOT_METERS_VALUES_FG: "UPDATE_JACKPOT_METERS_VALUES_FG",
  START_BONUS_SYM_TRAIL: "START_BONUS_SYM_TRAIL",
  RESET_BONUS_TRAIL_DATA: "RESET_BONUS_TRAIL_DATA",
  BONUS_TRAIL_COMPLETED: "BONUS_TRAIL_COMPLETED",
  ADD_STICKY_RANDOM_WILD: "ADD_STICKY_RANDOM_WILD",
  UPDATE_WIN_AMT_POS: "UPDATE_WIN_AMT_POS",
  STICKY_WILD_ADDED: "STICKY_WILD_ADDED",
  HIDE_STICKY_WILD_CONTAINER: "HIDE_STICKY_WILD_CONTAINER",
  CREATE_STICKY_WILD_SPINE: "CREATE_STICKY_WILD_SPINE",
  PLAY_STICKY_WIN_ANIM: "PLAY_STICKY_WIN_ANIM",
  STOP_STICKY_WIN_ANIM: "STOP_STICKY_WIN_ANIM",
  HIDE_BASEGAME_REEL: "HIDE_BASEGAME_REEL",
  SHOW_BASEGAME_REEL: "SHOW_BASEGAME_REEL",
  PLAY_HIT_ANIMATION: "PLAY_HIT_ANIMATION",
  UPDATE_FINAL_POSITION: "UPDATE_FINAL_POSITION",
  SHOW_TOP_LOGO: "SHOW_TOP_LOGO",
  HIDE_TOP_LOGO: "HIDE_TOP_LOGO",
  SHOW_JACKPOT_BACKGROUND: "SHOW_JACKPOT_BACKGROUND",
  HIDE_JACKPOT_BACKGROUND: "HIDE_JACKPOT_BACKGROUND",
  SHOW_YOU_WON_BACKGROUND: "SHOW_YOU_WON_BACKGROUND",
  HIDE_YOU_WON_BACKGROUND: "HIDE_YOU_WON_BACKGROUND",
  // Hold and respin feature
  PLAY_HIT_ANIM_RESPIN: "PLAY_HIT_ANIM_RESPIN",
  UPDATE_TICKUP_WIN_METER: "UPDATE_TICKUP_WIN_METER",
  SHOW_TRIGGERED_SKULLS: "SHOW_TRIGGERED_SKULLS",
  INITIALIZE_HOLD_AND_RESPIN: "INITIALIZE_HOLD_AND_RESPIN",
  DESTROY_HOLD_AND_RESPIN: "DESTROY_HOLD_AND_RESPIN",
  SHOW_HOLD_AND_RESPIN_INTRO: "SHOW_HOLD_AND_RESPIN_INTRO",
  HIDE_BASEGAME_ON_FEATURE: "HIDE_BASEGAME_ON_FEATURE",
  ON_START_BONUS_PRESENTATION: "ON_START_BONUS_PRESENTATION",
  START_BONUS_WIN_ANIM: "START_BONUS_WIN_ANIM",
  SHOW_INITIAL_COINS_ON_REEL: "SHOW_INITIAL_COINS_ON_REEL",
  SHOW_AMOUNT_ON_MULTIPLER_REEL:"SHOW_AMOUNT_ON_MULTIPLER_REEL",
  INITIATE_REEL_SPINNING: "INITIATE_REEL_SPINNING",
  INITIALIZE_RESPIN_REELPANEL: "INITIALIZE_RESPIN_REELPANEL",
  PARSE_NEXT_RESPIN_DATA: "PARSE_NEXT_RESPIN_DATA",
  FEATURE_REEL_STOPPING: "FEATURE_REEL_STOPPING",
  FEATURE_REEL_STOPPED: "FEATURE_REEL_STOPPED",
  SHOW_SYMBOL_ON_REEL: "SHOW_SYMBOL_ON_REEL",
  UPDATED_COLLECTED_COINS: "UPDATED_COLLECTED_COINS",
  UPDATE_SPIN_REMAINING_COUNT: "UPDATE_SPIN_REMAINING_COUNT",
  ON_FEATURE_SPIN_COMPLETE: "ON_FEATURE_SPIN_COMPLETE",
  RESET_SPIN_LEFT_COUNTER: "RESET_SPIN_LEFT_COUNTER",
  REMOVE_BONUS_FROM_WINPRESENTATION: "REMOVE_BONUS_FROM_WINPRESENTATION",
  UPDATE_SYMBOL_PRICE_MULTIPLER: "UPDATE_SYMBOL_PRICE_MULTIPLER",
  UPDATE_SYMBOL_PRICE_BIG_PRIZE: "UPDATE_SYMBOL_PRICE_BIG_PRIZE",
  UPDATE_SYMBOL_PRICE_COLLECT_ALL: "UPDATE_SYMBOL_PRICE_COLLECT_ALL",
  HIDE_HOLD_AND_RESPIN_BACKGROUND: "HIDE_HOLD_AND_RESPIN_BACKGROUND",
  PLAY_WIN_ANIM_LEFT_CHARACTER: "PLAY_WIN_ANIM_LEFT_CHARACTER",
  PLAY_MULTIPLIER_LOOP_ANIM: "PLAY_MULTIPLIER_LOOP_ANIM",
  STOP_MULTIPLIER_LOOP_ANIM: "STOP_MULTIPLIER_LOOP_ANIM",
  PLAY_ALL_SKULL_ANIM: "PLAY_ALL_SKULL_ANIM",
  RESUME_WIN_COLLECTION: "RESUME_WIN_COLLECTION",
  SHOW_AMOUNT_ON_BIG_PRIZE_REEL: "SHOW_AMOUNT_ON_BIG_PRIZE_REEL",
  //  HOLD AND RE SPIN LOGIC
  SHOW_NEXT_FEATURE_PRESENTATION: "SHOW_NEXT_FEATURE_PRESENTATION",
  //  JACKPOT FEATURE
  SHOW_JACKPOT_OUTRO: "SHOW_JACKPOT_OUTRO",
  // YOU WON PRESENTATION
  SHOW_YOU_WON_OUTRO: "SHOW_YOU_WON_OUTRO",
  SET_WIN_VALUE: "SET_WIN_VALUE",
  // Hold and respin feature
  HIDE_BONUS_REEL: "HIDE_BONUS_REEL",
  SHOW_BONUS_REEL: "SHOW_BONUS_REEL",
  RESET_COUNTERS: "RESET_COUNTERS",
  START_WIN_COLLECTION: "START_WIN_COLLECTION",
  PLAY_HOLD_AND_RESPIN_BLAST_ON_WIN_METER: "PLAY_HOLD_AND_RESPIN_BLAST_ON_WIN_METER",
  PLAY_BONUS_WIN_ANIM: "PLAY_BONUS_WIN_ANIM",
  UPDATE_BONUS_WIN_MTR_ON_PORTRAIT: "UPDATE_BONUS_WIN_MTR_ON_PORTRAIT",
  SHOW_BONUS_WIN_MTR_PORTRAIT: "ToShowPortraitBonusWinMtr",
  HIDE_BONUS_WIN_MTR_PORTRAIT: "ToHidePortraitBonusWinMtr",
  BONUS_SYMBOL_WIN_COMPLETE: "BONUS_SYMBOL_WIN_COMPLETE",
  END_WIN_COLLECTION_TICKUP: "END_WIN_COLLECTION_TICKUP",
  SHOW_AMOUNT_ON_COLLECT_ALL_REEL: "SHOW_AMOUNT_ON_COLLECT_ALL_REEL",
  AUTO_CLICKED_START: "AUTO_CLICKED_START",
  HIDE_WILD_SYMBOL_ON_REEL: "HIDE_WILD_SYMBOL_ON_REEL",
  SHOW_BONUS_OUTRO: "SHOW_BONUS_OUTRO",
  PLAY_WIN_COLLECTION_COIN_TRAIL: "PLAY_WIN_COLLECTION_COIN_TRAIL",
  RESET_WIN_COLLECTION_COIN_TRAIL: "RESET_WIN_COLLECTION_COIN_TRAIL",
  ADD_LIGHTNING_VIEW_ON_TOP: "ADD_LIGHTNING_VIEW_ON_TOP",
  CHECK_FOR_MULTIPLER_ON_REEL:"CHECK_FOR_MULTIPLER_ON_REEL",
  CHECK_FOR_COLLECT_ALL_ON_REEL:"CHECK_FOR_COLLECT_ALL_ON_REEL",

  //big win
  SHOW_POP_UP_BLUR_BG: "SHOW_POP_UP_BLUR_BG",
  HIDE_POP_UP_BLUR_BG: "HIDE_POP_UP_BLUR_BG",
  HIDE_FREEGAME_BIG_WIN: "HIDE_FREEGAME_BIG_WIN",
  SHOW_JACKPOT_BG:"SHOW_JACKPOT_BG",
  SHOW_YOU_WON_BG:"SHOW_YOU_WON_BG",
  SHOW_INTRO_BG:"SHOW_INTRO_BG",
  HIDE_INTRO_BG:"HIDE_INTRO_BG",
  TOP_LOGO_HIDE_ON_BIG_WIN_FG:"TOP_LOGO_HIDE_ON_BIG_WIN_FG",
  TOP_LOGO_SHOW_ON_BIG_WIN_FG:"TOP_LOGO_SHOW_ON_BIG_WIN_FG"
};
